import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-554a0ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bars" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px","width":"150px"} }, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { class: "zhCNnum" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px","width":"30px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, null, -1))

import { onMounted, reactive, ref, toRefs } from 'vue';
import { zhCNnum } from '@/Utils/Common';
import { toJourneyById } from '@/Utils/Common';

/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBars',
  props: {
    len: {},
    ida: {}
  },
  setup(__props: any) {

const props = __props;


const { len, ida } = toRefs(props); //
const nowIndex = ref(0);
const dotStyle = ref({
    width: '15px',
    height: '15px',
    left: '-30.2px',
    backgroundColor: ' #ff7b00',
    border: '2px solid #fcb36f',
})

const GoToJourneyById = (index: number, idName: string) => {
    nowIndex.value = index;
    toJourneyById(idName);
}

const isScroll = reactive({
    overflowY: 'scroll' as any
})


const elements: any = [];
onMounted(() => {
    // for (let i = 0; i < len.value; i++) {
    //     elements.push(document.getElementById(ida.value + i))
    // }
    // runEventListener();
})

// const runEventListener = () => {
//   window.addEventListener('scroll', function () {
//     let wst = document.documentElement.scrollTop || document.body.scrollTop;
//     for (let i = 0; i < elements.length; i++) {
//       if (elements[i]) {
//         if (elements[i].offsetTop <= wst) {
//           // 元素滚动到顶部的逻辑处理
//           console.log("元素已滚动到顶部！");
//           nowIndex.value = i;
//         }
//       }
//     }
//   });
// };






/* eslint-enable */



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "nacigationBars",
      style: _normalizeStyle(_unref(len) > 15 ? isScroll : {})
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(len), (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "Nnum",
            key: index,
            onClick: ($event: any) => (GoToJourneyById(index, _unref(ida) + index.toString()))
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, " D" + _toDisplayString(i), 1),
            _createElementVNode("div", _hoisted_9, " 第" + _toDisplayString(_unref(zhCNnum)(i)) + "天 ", 1)
          ], 8, _hoisted_6))
        }), 128)),
        _hoisted_10
      ])
    ], 4),
    _hoisted_11
  ]))
}
}

})